const SignOut = () => import('@/views/auth/SignOut.vue').then((m) => m.default);
const SignIn = () => import('@/views/auth/SignIn.vue').then((m) => m.default);
const SignUp = () => import('@/views/auth/SignUp.vue').then((m) => m.default);
const AcceptInvitation = () =>
	import('@/views/auth/AcceptInvitation.vue').then((m) => m.default);
const ForgotPassword = () =>
	import('@/views/auth/ForgotPassword.vue').then((m) => m.default);
const ForgotPasswordConfirm = () =>
	import('@/views/auth/ForgotPasswordConfirm.vue').then((m) => m.default);
const ResendSignUp = () =>
	import('@/views/auth/ResendSignUp.vue').then((m) => m.default);
const VerifyAccount = () =>
	import('@/views/auth/VerifyAccount.vue').then((m) => m.default);
const ConfirmAccount = () =>
	import('@/views/auth/ConfirmAccount.vue').then((m) => m.default);
const onBoarding = () =>
	import('@/views/onBoarding/index.vue').then((m) => m.default);
import Route from '@/entities/Route';
import RouteNames from '@/entities/RouteNames';
import Roles from '@/entities/Roles';

export const authRoutes: Route[] = [
	{
		path: '/signup/company',
		name: RouteNames.SIGNUP,
		component: SignUp,
		meta: {
			title: 'Sign Up',
			redirectIfAuth: true,
		},
		// children: [
		// 	{
		// 	  path: ":id",
		// 	  name: RouteNames.SIGNUP,
		// 	  component: SignUp,
		// 	  meta: {
		// 		title: 'Sign Up',
		// 		redirectIfAuth: true,
		// 	  },
		// 	},
		//   ],
	},
	{
		path: '/signin',
		name: RouteNames.SIGNIN,
		component: SignIn,
		meta: {
			title: 'Sign In',
			redirectIfAuth: true,
		},
	},
	{
		path: '/login',
		name: RouteNames.LOGIN,
		component: SignIn,
		meta: {
			title: 'Sign In',
			redirectIfAuth: true,
		},
	},
	{
		path: '/signout',
		name: RouteNames.SIGNOUT,
		component: SignOut,
		meta: {
			title: 'Sign Out',
		},
	},
	{
		path: '/logout',
		name: RouteNames.LOGOUT,
		component: SignOut,
		meta: {
			title: 'Log Out',
		},
	},
	{
		path: '/accept-invitation',
		name: RouteNames.ACCEPT_INVITATION,
		component: AcceptInvitation,
		meta: {
			title: 'Accept Invitation',
			redirectIfAuth: true,
		},
	},
	{
		path: '/verify-account',
		name: RouteNames.VERIFY_ACCTOUNT,
		component: VerifyAccount,
		meta: {
			title: 'Verify Account',
			redirectIfAuth: true,
		},
	},
	{
		path: '/forgot-password',
		name: RouteNames.FORGOT_PASSWORD,
		component: ForgotPassword,
		meta: {
			title: 'Forgot Password',
			redirectIfAuth: true,
		},
	},
	{
		path: '/forgot-password-confirm',
		name: RouteNames.FORGOT_PASSWORD_CONFIRM,
		component: ForgotPasswordConfirm,
		meta: {
			title: 'Forgot Password Confirm',
			redirectIfAuth: true,
		},
	},
	{
		path: '/resend-signup',
		name: RouteNames.RESEND_SIGNUP,
		component: ResendSignUp,
		meta: {
			title: 'Resend Confirmation',
			redirectIfAuth: true,
		},
		props: true,
	},
	{
		path: '/confirm_account/:email/:company',
		name: RouteNames.CONFIRM_ACCOUNT,
		component: ConfirmAccount,
		props: true,
		meta: {
			title: 'Confirm Account',
			redirectIfAuth: true,
		},
	},
];
